export default __webpack_public_path__ + "static/media/beef-and-cheese.2843e4f3.jpg";